// extracted by mini-css-extract-plugin
module.exports = {"displayField":"DisplayField_displayField__3yh75","label":"DisplayField_label__1mXMs"};